/**
 * Live-tunable glass knobs. Production uses the baked defaults; the workspace
 * preview drives them from sliders.
 */
export interface LiquidGlassNavKnobs {
  /** Base refraction strength. */
  displacement: number;
  /** R↔B spread → rainbow chromatic aberration. */
  chromatic: number;
  /** Warp backdrop blur (px). */
  frost: number;
  /** Lens white-tint alpha. */
  tint: number;
  /** Lifted peak scaleY. */
  bulge: number;
  /** Displacement-map edge falloff. */
  edge: number;
  /** Edge blur-ring width (px). */
  ringThickness: number;
  /** Edge blur-ring strength (px). */
  ringBlur: number;
  /** Specular highlight angle (degrees). Controls the direction of the lens rim light. */
  specularAngle: number;
  /** Ambient centre glow alpha (0–1). Adds a radial brightening at the lens centre. */
  glow: number;
}

export const DEFAULT_KNOBS: LiquidGlassNavKnobs = {
  displacement: 100,
  chromatic: 20,
  frost: 1,
  tint: 0.06,
  bulge: 1.42,
  edge: 2.4,
  ringThickness: 14,
  ringBlur: 8,
  specularAngle: 115,
  glow: 0,
};

/** Capability probe — does the browser apply an SVG-filter url() in backdrop-filter? */
export function supportsBackdropSvg(): boolean {
  const t = document.createElement('div');
  t.style.backdropFilter = 'url(#lgnav-probe-filter)';
  if (t.style.backdropFilter.includes('url')) return true;
  // Safari prefix
  const styleWithPrefix = t.style as CSSStyleDeclaration & { webkitBackdropFilter?: string };
  styleWithPrefix.webkitBackdropFilter = 'url(#lgnav-probe-filter)';
  return (styleWithPrefix.webkitBackdropFilter ?? '').includes('url');
}
